export enum WhomAssignee {
  COMPANY = 'company',
  FILIAL = 'company_branch',
  DIVISION = 'company_branch_subdivision',
  POSITION = 'company_branch_subdivision_job_position',
  EMPLOYEE = 'employees',
}
